import React, {PureComponent} from "react"
import moment from "moment"

import {Deal} from "@irati/types"
import {
  userDOBExists,
  userDOBIsWithinRedemptionWindow,
  getEarliestRedemptionDate
} from "@irati/deals/helpers/deals/redemptionEvents/dateOfBirth"

import DateOfBirthRequiredBlock from "./DateOfBirthRequiredBlock"
import PerkNotAvailableBlock from "./PerkNotAvailableBlock"
import PerkAvailableBlock from "./PerkAvailableBlock"

import {Background, Wrapper} from "../styled"
import {OnDealSubmit} from "../../../../containers/DealInfo"

interface Props {
  id?: string,
  deal: Deal,
  emoji: string,
  onSubmit: OnDealSubmit
}

const Inner = (props: Props) => {
  const {deal, emoji, onSubmit} = props

  if (userDOBExists() && userDOBIsWithinRedemptionWindow(deal)) {
    return <PerkAvailableBlock redeemHeaderEmoji={emoji} onClickRedeem={onSubmit} />
  } else if (userDOBExists() && !userDOBIsWithinRedemptionWindow(deal)) {
    const today = moment()
    const earliestRedemptionDate = getEarliestRedemptionDate(deal)

    const date = moment(earliestRedemptionDate).isBefore(today) ? moment(earliestRedemptionDate).add(1, "y") : earliestRedemptionDate!

    return <PerkNotAvailableBlock availableDate={date} redeemHeaderEmoji={emoji} onClickRedeem={onSubmit} />
  } else {
    return <DateOfBirthRequiredBlock />
  }
}

class BirthdayBoxCTA extends PureComponent<Props> {
  static defaultProps: Pick<Props, "emoji"> = {
    emoji: "🎂"
  }

  render() {
    return (
      <Background>
        <Wrapper>
          <Inner {...this.props} />
        </Wrapper>
      </Background>
    )
  }
}

export default BirthdayBoxCTA
